"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABS = void 0;
exports.ABS = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:ABS not implemented');
    },
};
//# sourceMappingURL=abs.js.map